<template>
    <div class="relative">
        <CCard>
            <CCardHeader>
                <p>Настройки главной страницы</p>
            </CCardHeader>
            <CCardBody v-if="model" class="d-flex">
                <div class="flex-1 pr-4">
                    <div class="overflow-hidden border border-gray-300 rounded-md p-2 mb-4">
                        <CRow>
                            <CCol class="d-flex align-items-center flex-wrap justify-content-between">
                                <div class="flex items-center">
                                    <CSwitch
                                        :checked.sync="model.settings.pictures.active"
                                        color="success"
                                        shape="pill"
                                        size="sm"
                                    />
                                    <span class="ml-4 text-lg font-medium">Праздничные фоны</span>
                                </div>
                            </CCol>
                        </CRow>

                        <div v-if="model.settings.pictures.active" class="mt-4">
                            <div class="overflow-hidden border border-gray-300 rounded-md p-2 mb-2">
                                <CRow>
                                    <CCol col="4" class="col-form-label">
                                        Картинка для фона шапки до 320px
                                    </CCol>
                                    <CCol col="4">
                                        До 320px левая часть
                                        <CImg
                                            v-if="model.settings.pictures.header_320_left"
                                            :src="pictureUrl(model.settings.pictures.header_320_left)"
                                            class="m2"
                                            width="200" />
                                        <CInputFile
                                            horizontal
                                            @change="selectPicture('header_320_left', $event)" />
                                    </CCol>
                                    <CCol col="4">
                                        До 320px правая часть
                                        <CImg
                                            v-if="model.settings.pictures.header_320_right"
                                            :src="pictureUrl(model.settings.pictures.header_320_right)"
                                            class="m2"
                                            width="200" />
                                        <CInputFile
                                            horizontal
                                            @change="selectPicture('header_320_right', $event)" />
                                    </CCol>
                                </CRow>
                            </div>
                            <div class="overflow-hidden border border-gray-300 rounded-md p-2 mb-2">
                                <CRow>
                                    <CCol col="4" class="col-form-label">
                                        Картинка для фона шапки до 375px
                                    </CCol>
                                    <CCol col="4">
                                        До 375px левая часть
                                        <CImg
                                            v-if="model.settings.pictures.header_375_left"
                                            :src="pictureUrl(model.settings.pictures.header_375_left)"
                                            class="m2"
                                            width="200" />
                                        <CInputFile
                                            horizontal
                                            @change="selectPicture('header_375_left', $event)" />
                                    </CCol>
                                    <CCol col="4">
                                        До 375px правая часть
                                        <CImg
                                            v-if="model.settings.pictures.header_375_right"
                                            :src="pictureUrl(model.settings.pictures.header_375_right)"
                                            class="m2"
                                            width="200" />
                                        <CInputFile
                                            horizontal
                                            @change="selectPicture('header_375_right', $event)" />
                                    </CCol>
                                </CRow>
                            </div>
                            <div class="overflow-hidden border border-gray-300 rounded-md p-2 mb-2">
                                <CRow>
                                    <CCol col="4" class="col-form-label">
                                        Картинка для фона
                                    </CCol>
                                    <CCol col="4">
                                        До 320px
                                        <CImg
                                            v-if="model.settings.pictures.bg_320"
                                            :src="pictureUrl(model.settings.pictures.bg_320)"
                                            class="m2"
                                            width="200" />
                                        <CInputFile
                                            horizontal
                                            @change="selectPicture('bg_320', $event)" />
                                    </CCol>
                                    <CCol col="4">
                                        До 375px
                                        <CImg
                                            v-if="model.settings.pictures.bg_375"
                                            :src="pictureUrl(model.settings.pictures.bg_375)"
                                            class="m2"
                                            width="200" />
                                        <CInputFile
                                            horizontal
                                            @change="selectPicture('bg_375', $event)" />
                                    </CCol>
                                </CRow>
                            </div>
                        </div>
                    </div>

                    <div 
                        v-for="(item, idx) in model.settings.services_list"
                        :key="`services-adsBanner-${ item.id }-${ idx }`">
                        <div v-if="item.type === 'adsBanner'" class="overflow-hidden border border-gray-300 rounded-md p-2 mb-4">
                            <CRow>
                                <CCol class="d-flex align-items-center flex-wrap justify-content-between">
                                    <div class="flex items-center">
                                        <CSwitch
                                            :checked.sync="item.active"
                                            color="success"
                                            shape="pill"
                                            size="sm"
                                        />
                                        <span class="ml-4 text-lg font-medium">Рекламное место</span>
                                    </div>
                                    <CButton
                                        shape="pill"
                                        color="success"
                                        variant="ghost"
                                        @click="openBanners(item)"
                                    >
                                        <CIcon
                                            :height="24"
                                            :content="$options.icons.cilSettings"
                                        />
                                        Настройки
                                    </CButton>
                                </CCol>
                            </CRow>
                        </div>
                    </div>
                    <div 
                        v-for="(item, idx) in model.settings.services_list"
                        :key="`services-selectionCarousel-${ item.id }-${ idx }`">
                        <div v-if="item.blockType === 'selectionCarousel'" class="overflow-hidden border border-gray-300 rounded-md p-2 mb-4">
                            <CRow>
                                <CCol class="d-flex align-items-center flex-wrap justify-content-between">
                                    <div class="flex items-center">
                                        <CSwitch
                                            :checked.sync="item.active"
                                            color="success"
                                            shape="pill"
                                            size="sm"
                                        />
                                        <span class="ml-4 text-lg font-medium">{{ item.title }} </span>
                                    </div>
                                    <CButton
                                        shape="pill"
                                        color="success"
                                        variant="ghost"
                                        @click="openSelectionCarouselBanners(item)"
                                    >
                                        <CIcon
                                            :height="24"
                                            :content="$options.icons.cilSettings"
                                        />
                                        Настройки
                                    </CButton>
                                </CCol>
                            </CRow>
                        </div>
                    </div>
                    <div 
                        v-for="(item, idx) in model.settings.services_list"
                        :key="`services-bestUserServicesCarousel-${ item.id }-${ idx }`">
                        <div v-if="item.blockType === 'bestUserServicesCarousel'" class="overflow-hidden border border-gray-300 rounded-md p-2 mb-4">
                            <CRow>
                                <CCol class="d-flex align-items-center flex-wrap justify-content-between">
                                    <div class="flex items-center">
                                        <CSwitch
                                            :checked.sync="item.active"
                                            color="success"
                                            shape="pill"
                                            size="sm"
                                        />
                                        <span class="ml-4 text-lg font-medium">Карусель "Уже заказывали" </span>
                                    </div>
                                </CCol>
                            </CRow>
                        </div>
                    </div>
                    <div 
                        v-for="(item, idx) in model.settings.services_list"
                        :key="`services-assistantBlock-${ item.id }-${ idx }`">
                        <div v-if="item.blockType === 'assistantBlock'" class="overflow-hidden border border-gray-300 rounded-md p-2 mb-4">
                            <CRow>
                                <CCol class="d-flex align-items-center flex-wrap justify-content-between">
                                    <div class="flex items-center">
                                        <CSwitch
                                            :checked.sync="item.active"
                                            color="success"
                                            shape="pill"
                                            size="sm"
                                        />
                                        <span class="ml-4 text-lg font-medium">{{ item.title }} </span>
                                    </div>
                                    <CButton
                                        shape="pill"
                                        color="success"
                                        variant="ghost"
                                        @click="openAssistantBlockBanners(item)"
                                    >
                                        <CIcon
                                            :height="24"
                                            :content="$options.icons.cilSettings"
                                        />
                                        Настройки
                                    </CButton>
                                </CCol>
                            </CRow>
                        </div>
                    </div>

                    <div class="overflow-hidden border border-gray-300 rounded-md p-2">
                        <div class="pl-2 pt-1 pb-3 text-lg font-medium">Сервисы</div>
                        <Draggable v-model="model.settings.services_list" tag="div">
                            <div
                                v-for="(item, idx) in model.settings.services_list"
                                :key="`services-list-${ item.id }-${ idx }`"
                            >
                    <div
                        v-if="item.type !== 'adsBanner' && item.blockType !== 'selectionCarousel' && item.blockType !== 'bestUserServicesCarousel' && item.blockType !== 'assistantBlock'" 
                        :class="{'border-green-500': item.active}"
                        class="px-6 py-2 my-1 border rounded-md cursor-move"
                    >
                                    <div 
                                        class="d-flex align-items-center flex-wrap justify-content-between">
                                        <div class="flex items-center">
                                            <CSwitch
                                                :checked.sync="item.active"
                                                color="success"
                                                shape="pill"
                                                size="sm"
                                            />
                                            <span class="ml-4 text-lg font-medium">{{ item.bannerId ? `${item.title} (Баннер)` : item.title }}</span>
                                        </div>
                                        <CButton
                                            shape="pill"
                                            color="success"
                                            variant="ghost"
                                            @click="openModal(item)"
                                        >
                                            <CIcon
                                                :height="24"
                                                :content="$options.icons.cilSettings"
                                            />
                                            Настройки
                                        </CButton>
                                    </div>
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
                <div width="392" class="d-flex justify-content-center relative">
                    <div class="app_iframe_sticky">
                        <iframe :src="appHomePageUrl()" ref="app_iframe" :key="iframeUpdate" width="392" height="846" class="overflow-hidden border border-gray-300 rounded-md"></iframe>
                    </div>
                </div>
            </CCardBody>


            <CCardFooter>
                <CButton
                    class="ml-auto"
                    color="primary"
                    @click="submit">
                    Сохранить
                </CButton>
            </CCardFooter>
        </CCard>

        <CElementCover
            v-if="isPending"
            :opacity="0.8"
        >
            <div class="flex items-center">
                <CSpinner size="sm" />
                <p class="ml-2 text-xl">Сохранение... </p>
            </div>
        </CElementCover>

        <CModal
            :title="selectedItem.title"
            color="primary"
            :show.sync="isModalBanners"
        >
            <template v-if="isModalBanners">
                <CRow>
                    <CCol class="align-items-center d-flex mb-2">
                        <span class="mr-2">На всю ширину экрана: </span>
                        <CSwitch
                            :checked.sync="selectedItem.horizontal"
                            color="success"
                            shape="pill"
                            size="sm"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol class="align-items-center d-flex mb-2">
                        <span class="mr-2"> Авторотация </span>
                        <CSwitch
                            :checked.sync="selectedItem.auto_rotation"
                            color="success"
                            shape="pill"
                            size="sm"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol>
                        <CInput
                            v-model.number="selectedItem.height"
                            label="Высота"
                            horizontal
                            placeholder="Введите высоту"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol>
                        <CInput
                            v-model.number="selectedItem.heightPercent"
                            label="Высота (%)"
                            horizontal
                            placeholder="Введите высоту в процентах от ширины экрана"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol>
                        <CInput
                            v-model.number="selectedItem.heightPixels"
                            label="Высота (px)"
                            horizontal
                            placeholder="Введите высоту в пикселях"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol>
                        <CInput
                            v-model.number="selectedItem.switching_time"
                            label="Время переключения"
                            horizontal
                            placeholder="милисекунды"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol>
                        <span>Банеры:</span>
                        <div
                            v-for="(item, index2) in model.banners"
                            :key="`banners-${ item.id }-${ index2 }`"
                            :class="{'border-green-500': item.active}"
                            class="flex px-6 py-2 my-1 border rounded-md justify-content-between"
                        >
                            {{ item.title }}
                            <CButton
                                shape="pill"
                                color="success"
                                variant="ghost"
                                @click="toggleBanner(item)"
                            >
                                {{ !!ads.banners.find((b) => b.id === item.id) ? 'Удалить' : 'Добавить' }}
                            </CButton>
                        </div>
                    </CCol>
                </CRow>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="isModalBanners = false">Отмена</CButton>

                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="saveItem">Сохранить</CButton>
                </div>
            </template>
        </CModal>

        <CModal
            :title="selectedItem.title"
            color="primary"
            :show.sync="isModalSelectionCarouselBanners"
        >
            <template v-if="isModalSelectionCarouselBanners">
                <CRow>
                    <CCol class="align-items-center d-flex mb-2">
                        <span class="mr-2">На всю ширину экрана: </span>
                        <CSwitch
                            :checked.sync="selectedItem.horizontal"
                            color="success"
                            shape="pill"
                            size="sm"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol>
                        <CInput
                            v-model.number="selectedItem.height"
                            label="Высота"
                            horizontal
                            placeholder="Введите высоту"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol>
                        <CInput
                            v-model.number="selectedItem.heightPercent"
                            label="Высота (%)"
                            horizontal
                            placeholder="Введите высоту в процентах от ширины экрана"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol>
                        <CInput
                            v-model.number="selectedItem.heightPixels"
                            label="Высота (px)"
                            horizontal
                            placeholder="Введите высоту в пикселях"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol>
                        <CInput
                            v-model="selectedItem.blockTitle"
                            label="Заголовок"
                            horizontal
                            placeholder="Заголовок"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol>
                        <CInput
                            v-model="selectedItem.startVersion"
                            label="Версия"
                            horizontal
                            placeholder="С какой версии показывать"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol>
                        <span>Банеры:</span>
                        <div
                            v-for="(item, idx) in selectionCarouselBanners"
                            :key="`selectionCarouselBanners-${ item.id }-${ idx }`"
                            :class="{'border-green-500': item.enabled}"
                            class="flex px-6 py-2 my-1 border rounded-md"
                        >
                            <CSwitch
                                :checked.sync="selectedItem.selectedBanners[item.id]"
                                color="success"
                                shape="pill"
                                size="sm"
                                class="mr-2"
                            />
                            {{ item.title }}
                        </div>
                    </CCol>
                </CRow>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="isModalSelectionCarouselBanners = false">Отмена</CButton>

                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="saveItem">Сохранить</CButton>
                </div>
            </template>
        </CModal>

        <CModal
            :title="selectedItem.title"
            color="primary"
            :show.sync="isModalAssistantBlockBanners"
        >
            <template v-if="isModalAssistantBlockBanners">
                <CRow>
                    <CCol>
                        <CInput
                            v-model="selectedItem.blockTitle"
                            label="Заголовок"
                            horizontal
                            placeholder="Заголовок"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol>
                        <CInput
                            v-model="selectedItem.link"
                            label="Ссылка"
                            horizontal
                            placeholder="Ссылка"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol>
                        <CInput
                            v-model="selectedItem.startVersion"
                            label="Версия"
                            horizontal
                            placeholder="С какой версии показывать"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol>
                        <span>Банеры:</span>
                        <div
                            v-for="(item, idx) in assistantBlockBanners"
                            :key="`assistantBlockBanners-${ item.id }-${ idx }`"
                            :class="{'border-green-500': item.enabled}"
                            class="flex px-6 py-2 my-1 border rounded-md"
                        >
                            <CSwitch
                                :checked.sync="selectedItem.selectedBanners[item.id]"
                                color="success"
                                shape="pill"
                                size="sm"
                                class="mr-2"
                            />
                            {{ item.title }}
                        </div>
                    </CCol>
                </CRow>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="isModalAssistantBlockBanners = false">Отмена</CButton>

                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="saveItem">Сохранить</CButton>
                </div>
            </template>
        </CModal>

        <CModal
            :title="selectedItem.title"
            color="primary"
            :show.sync="settingsModal"
        >
            <template v-if="settingsModal">
                <CRow>
                    <CCol class="align-items-center d-flex mb-2">
                        <span class="mr-2">На всю ширину экрана: </span>
                        <CSwitch
                            :checked.sync="selectedItem.horizontal"
                            color="success"
                            shape="pill"
                            size="sm"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol>
                        <CInput
                            v-model.number="selectedItem.height"
                            label="Высота"
                            horizontal
                            placeholder="Введите высоту"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol>
                        <CInput
                            v-model.number="selectedItem.heightPercent"
                            label="Высота (%)"
                            horizontal
                            placeholder="Введите высоту в процентах от ширины экрана"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol>
                        <CInput
                            v-model.number="selectedItem.heightPixels"
                            label="Высота (px)"
                            horizontal
                            placeholder="Введите высоту в пикселях"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol>
                        <span>Банеры:</span>
                        <div
                            v-for="(item, idx) in filteredServices"
                            :key="`filteredServices-${ item.id }-${ idx }`"
                            :class="{'border-green-500': item.active}"
                            class="flex px-6 py-2 my-1 border rounded-md cursor-move"
                        >
                            <CSwitch
                                :checked.sync="selectedItem.show_on_pages[item.finalCode]"
                                color="success"
                                shape="pill"
                                size="sm"
                                class="mr-2"
                            />
                            {{ item.title }}
                        </div>
                    </CCol>
                </CRow>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="settingsModal = false">Отмена</CButton>

                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="saveItem">Сохранить</CButton>
                </div>
            </template>
        </CModal>
    </div>
</template>

<script>
    import Draggable from 'vuedraggable';
    import { cilSettings } from '@coreui/icons';

    export default {
        components: {
            Draggable
        },

        icons: {
            cilSettings,
        },

        data: () => ({
            iframeUpdate: false,
            isPending: false,
            isModalBanners: false,
            settingsModal: false,
            isModalSelectionCarouselBanners: false,
            isModalAssistantBlockBanners: false,
            selectedPictures: {
                header_320_left: null,
                header_320_right: null,
                header_375_left: null,
                header_375_right: null,
                bg_320: null,
                bg_375: null
            },
            selectedItem: {
                bannerId: null,
                picture: '',
                picture_main_page: '',
                picture_main_page_sq: '',
                title: '',
                title_formatted: '',
                typeCode: '',
                value: '',
                horizontal: false,
                active: false,
                height: 100,
                heightPercent: 50,
                heightPixels: 0,
                show_on_pages: {},
                type: '',
                auto_rotation: false,
                switching_time: null,
            },
            model: {
                id: 0,
                page: 'home',
                settings: {
                    promotions_visible: true,
                    pictures: {
                        active: false,
                        header: null,
                        bg: null,
                    },
                    services_list: []
                }
            },
            servicesList: [],
            defaultServicesList: [
                {
                    title: 'Карусель подборок на главной',
                    horizontal: true,
                    blockType: 'selectionCarousel',
                    banners: [],
                    active: false,
                    height: 0,
                },
                {
                    title: 'Карусель "Уже заказывали"',
                    horizontal: true,
                    blockType: 'bestUserServicesCarousel',
                    services: [],
                    active: false,
                    height: 70,
                    blockTitle: 'Уже заказывали'
                },
                {
                    title: 'Блок Личный помощник',
                    horizontal: true,
                    blockType: 'assistantBlock',
                    banners: [],
                    active: false,
                    height: 0,
                },
                {
                    title: 'Рестораны',
                    horizontal: true,
                    value: 'restaurant',
                    active: true,
                    height: 100,
                },
                {
                    title: 'Магазины',
                    horizontal: false,
                    value: 'grocery',
                    active: true,
                    height: 100,
                },
                {
                    title: 'Аптека',
                    horizontal: false,
                    value: 'pharmacy',
                    active: false,
                    height: 100,
                },
            ],
            bannersList: []
        }),

        computed: {
            ads(){
                const ads = this.model.settings.services_list.find(e => e.type === 'adsBanner');
                return ads;
            },
            activeServices() {
                if (!this.servicesList.length) {
                    return []
                }

                const checkActive = this.servicesList.map(item => {
                    if (item.length) {
                        return [...item.filter(el => el.active)]
                    }
                    return item.active ? item : null;
                });

                return checkActive.filter(el => el?.active || el?.length);
            },
            filteredServices() {
                return this.model.settings.services_list.filter(item => item.value !== 'banner' && item.blockType !== 'selectionCarousel').map(item => {
                    return {
                        ...item,
                        ...{ finalCode: item.typeCode ? item.typeCode : item.value }
                    }
                })
            },
            selectionCarouselBanners() {
                return this.bannersList.filter(item => item.for_selection_carousel);
            },
            assistantBlockBanners() {
                return this.bannersList.filter(item => item.for_assistant_block);
            }
        },

        watch: {
            model: {
                deep: true,
                handler() {
                    let list = [...this.model.settings.services_list];

                    list = list
                        .map((item, index) => {
                            if (!item) {
                                return item;
                            }

                            if (item.horizontal) {
                                return item;
                            }

                            if (item && !item.horizontal && list[index + 1] && !list[index + 1].horizontal) {
                                const group = [ item, { ...list[index + 1] } ];
                                list[index + 1] = null;
                                return group;
                            }

                            return [ item ];
                        })
                        .filter(item => !!item);

                    this.servicesList = list;
                }
            }
        },

        async created() {
            await this.fetchEntity();
            const { data: bannersList } = await this.axios.get('/banners');
            this.bannersList = bannersList;
        },

        methods: {
            toggleBanner( banner ){
                const adsBanner = this.model.settings.services_list.find(e => e.type === 'adsBanner');
                if(adsBanner.banners) {
                    var bannerIndex = adsBanner.banners.findIndex(b => b.id === banner.id);

                    if (bannerIndex === -1){
                        adsBanner.banners.push(banner);
                    } else {
                        adsBanner.banners.splice(bannerIndex, 1);
                    }
                }
            },
            pictureUrl(picture) {
                return picture ? (process.env.VUE_APP_STATIC_BASE_URL + '/' + picture) : '';
            },
            appHomePageUrl() {
                return `${process.env.VUE_APP_APP_URL}/#!/home`;
            },

            async fetchEntity() {
                try {
                    this.isPending = true
                    const { data } = await this.axios.get('/page-settings/home');
                    if (data && data.settings) {
                        if(!data.settings?.pictures) {
                            data.settings.pictures = {
                                active: false,
                                header: null,
                                bg: null,
                            }
                        }
                        this.model = data;
                        
                        for(const defaultService of this.defaultServicesList) {
                            const check = this.model.settings.services_list.find(item => { 
                                return (
                                    (defaultService.blockType && item.blockType === defaultService.blockType) ||
                                    (defaultService?.value && item?.value === defaultService?.value)
                                    )
                            });
                            if(!check) {
                                this.model.settings.services_list.push(defaultService);
                            }
                        }
                    }
                    await this.fetchEntities(this.model);
                    this.handleBanners(this.model);
                    this.handleBannersAds(this.model);
                } catch (error) {
                    console.log(error);
                } finally {
                    setTimeout(() => {
                        this.isPending = false
                    }, 500)
                }
            },

            async fetchEntities(model) {
                try {
                    this.isPending = true;
                    // Get types
                    const { data } = await this.axios.get('/entities-type/');
                    const organizeEntities = data.map(({ title, title_formatted, code, picture, picture_main_page, picture_main_page_sq }) => ({
                        title,
                        title_formatted,
                        picture,
                        picture_main_page,
                        picture_main_page_sq,
                        value: 'entity',
                        typeCode: code,
                        active: false,
                        horizontal: false,
                        height: 100,
                        auto_rotation: false,
                        switching_time: null,
                    }));
                    const copyModel = await JSON.parse(JSON.stringify(model));
                    const services = this.updateList(copyModel.settings.services_list, organizeEntities, 'typeCode');
                    this.model.settings.services_list = [];
                    services.forEach((card, idx) => {
                        this.$set(this.model.settings.services_list, idx, card);
                    });
                } catch (error) {
                    console.log('Ошибка загрузки данных!');
                    return {};
                } finally {
                    setTimeout(() => {
                        this.isPending = false
                    }, 500)
                }
            },

            handleBanners(baseModel) {
                const model = { ...baseModel };

                let { banners } = model;

                banners = banners.map(banner => ({
                    bannerId: banner.id,
                    picture: banner.picture,
                    picture_main_page: banner.picture,
                    picture_main_page_sq: banner.picture,
                    title: banner.title,
                    value: 'banner',
                    active: false,
                    horizontal: false,
                    height: 100,
                    auto_rotation: false,
                    switching_time: null,
                }));
                const services = this.updateList(model.settings.services_list, banners, 'bannerId');
                this.model.settings.services_list = [];
                services.forEach((card, idx) => {
                    this.$set(this.model.settings.services_list, idx, card);
                });
            },

            handleBannersAds(baseModel) {
                const model = { ...baseModel };

                let { banners } = model;
                const adsBanners = [{
                    picture: '',
                    picture_main_page: '',
                    picture_main_page_sq: '',
                    title: 'Рекламное место',
                    value: 'banner',
                    active: false,
                    horizontal: false,
                    height: 100,
                    type: 'adsBanner',
                    banners: banners,
                    auto_rotation: false,
                    switching_time: null,
                }]
                const services = this.updateList(model.settings.services_list, adsBanners, 'type');
                this.model.settings.services_list = [];
                services.forEach((card, idx) => {
                    this.$set(this.model.settings.services_list, idx, card);
                });
            },

            updateList(list, cards, checkField) {
                const result = [...list]
                    .filter(service => !service[checkField] || cards.find(card => card[checkField] === service[checkField]));

                cards.forEach(card => {
                    const check = el => el.title === card.title && el[checkField] === card[checkField];
                    const condidate = result.findIndex(check);
                    if (condidate === -1) {
                        result.push(card);
                    } else {
                        result[condidate] = {
                            ...result[condidate],
                            picture: card.picture,
                            picture_main_page: card.picture_main_page,
                            picture_main_page_sq: card.picture_main_page_sq,
                            title: card.title,
                            title_formatted: card.title_formatted ? card.title_formatted : card.title,
                            height: result[condidate]?.height ? result[condidate]?.height : card?.height ? card?.height : 100
                        }
                    }
                });

                return result;
            },

            getTileClass(horizontal = false) {
                return horizontal ? 'Tile__container' : 'Tile__item';
            },

            getTileLabel(idx) {
                const service = this.activeServices[idx]
                return typeof service === 'object'
                    ? service.title
                    : ''
            },

            selectPicture(param, FileList) {
                this.selectedPictures[param] = FileList[0];
            },

            async submit() {
                try {
                    this.isPending = true;
                    const { id, ...data } = this.model;
                    data.settings.services_list = this.servicesList.flat()?.filter(item => {
                        if (['assistant', 'florist', 'laundry'].includes(item.value)) {
                            return false;
                        }
                        return true;
                    });

                    // Загружаем картинки
                    for(const param of Object.keys(this.selectedPictures)) {
                        if (this.selectedPictures[param]) {
                            let formData = new FormData();
                            formData.append('file', this.selectedPictures[param]);
                            const resp = await this.axios.post('/files/upload', formData);
                            data.settings.pictures[param] = resp.data.filename;
                        }
                    }
                    
                    if (id) {
                        await this.axios.put(`/page-settings/${id}`, data)
                    } else {
                        await this.axios.post('/page-settings', data)
                    }
                } finally {
                    setTimeout(() => {
                        this.iframeUpdate = !this.iframeUpdate;
                        this.isPending = false;
                    }, 500)
                }
            },

            saveItem() {
                const item = { ...this.selectedItem };
                for (const key in item) {
                    if ((key === 'bannerId' || key === 'typeCode' || key === 'type') && !item[key]) {
                        delete item[key];
                    }
                }
                let updatingItem = null;

                if(item.blockType === 'selectionCarousel') {
                    updatingItem = this.model.settings.services_list.findIndex(itm => itm.blockType === item.blockType);
                    if (updatingItem !== -1) {
                        item.banners = [];
                        for(const banner of this.selectionCarouselBanners) {
                            if(item.selectedBanners[banner.id] === true) {
                                item.banners.push(banner);
                            }
                        }
                        delete item.selectedBanners;
                        this.model.settings.services_list.splice(updatingItem, 1, item);
                    }
                } else if(item.blockType === 'assistantBlock') {
                    updatingItem = this.model.settings.services_list.findIndex(itm => itm.blockType === item.blockType);
                    if (updatingItem !== -1) {
                        item.banners = [];
                        for(const banner of this.assistantBlockBanners) {
                            if(item.selectedBanners[banner.id] === true) {
                                item.banners.push(banner);
                            }
                        }
                        delete item.selectedBanners;
                        this.model.settings.services_list.splice(updatingItem, 1, item);
                    }
                } else if (item.typeCode) {
                    updatingItem = this.model.settings.services_list.findIndex(itm => itm.typeCode === item.typeCode);
                    if (updatingItem !== -1) {
                        this.model.settings.services_list.splice(updatingItem, 1, item);
                    }
                } else if (item.bannerId) {
                    updatingItem = this.model.settings.services_list.findIndex(itm => itm.bannerId === item.bannerId);
                    if (updatingItem !== -1) {
                        this.model.settings.services_list.splice(updatingItem, 1, item);
                    }
                } else if (item.type){
                    updatingItem = this.model.settings.services_list.findIndex(itm => itm.type === item.type);
                    if (updatingItem !== -1) {
                        this.model.settings.services_list.splice(updatingItem, 1, item);
                    }
                } else {
                    updatingItem = this.model.settings.services_list.findIndex(itm => itm.value === item.value);
                    if (updatingItem !== -1) {
                        this.model.settings.services_list.splice(updatingItem, 1, item);
                    }
                }

                this.isModalBanners = false;
                this.settingsModal = false;
                this.isModalSelectionCarouselBanners = false;
                this.isModalAssistantBlockBanners = false;

                this.selectedItem = {
                    type: '',
                    blockType: '',
                    bannerId: null,
                    picture: '',
                    picture_main_page: '',
                    picture_main_page_sq: '',
                    title: '',
                    title_formatted: '',
                    typeCode: '',
                    value: '',
                    horizontal: false,
                    active: false,
                    height: 100,
                    show_on_pages: {},
                    bannersAds: {},
                    auto_rotation: false,
                    switching_time: null,
                    banners: []
                };
            },

            openModal(item) {
                this.selectedItem = {
                    ...{
                        show_on_pages: {}
                    },
                    ...item
                };
                this.isModalSelectionCarouselBanners = false;
                this.isModalAssistantBlockBanners = false;
                this.settingsModal = true;
                this.isModalBanners = false;
            },

            openBanners(item) {
                this.selectedItem = {
                    ...{
                        bannersAds: {}
                    },
                    ...item
                };
                this.isModalSelectionCarouselBanners = false;
                this.isModalAssistantBlockBanners = false;
                this.isModalBanners = true;
                this.settingsModal = false;
            },

            openSelectionCarouselBanners(item) {
                this.selectedItem = {
                    ...{
                        banners: [],
                        selectedBanners: {}
                    },
                    ...item
                };
                for(const item of this.selectedItem.banners) {
                    this.selectedItem.selectedBanners[item.id] = true;
                }
                this.isModalSelectionCarouselBanners = true;
                this.isModalBanners = false;
                this.settingsModal = false;
                this.isModalAssistantBlockBanners = false;
            },

            openAssistantBlockBanners(item) {
                this.selectedItem = {
                    ...{
                        banners: [],
                        selectedBanners: {}
                    },
                    ...item
                };
                for(const item of this.selectedItem.banners) {
                    this.selectedItem.selectedBanners[item.id] = true;
                }
                this.isModalAssistantBlockBanners = true;
                this.isModalSelectionCarouselBanners = false;
                this.isModalBanners = false;
                this.settingsModal = false;
            },
        }
    }
</script>

<style lang="scss">
.Tile {
    max-height: 568px;
    overflow-y: auto;
    @apply flex flex-col h-full p-2 border rounded-md cursor-pointer;

    &:hover {
        @apply shadow-md;
    }

    &.--selected {
        box-shadow: 0 0 1px 1px rgba(66, 153, 225, 1);
    }

    &__container {
        @apply flex flex-1 justify-between gap-2;
        height: auto;
        display: block;
        margin-bottom: 8px;
        .Tile__container > .Tile__container {
            margin-bottom: 0;
        }
        &:last-child {
            margin-bottom: 0;
        }
        & div {
            @apply flex flex-1 justify-center gap-2;

            overflow: hidden;
            position: relative;

            strong {
                position: absolute;
                top: 10px;
                left: 10px;
            }
        }

        &.--vertical {
            @apply flex-col;
        }
    }

    &__item {
        @apply flex justify-center items-center flex-1 bg-gray-300 rounded-md text-xs;
        text-align: center;
    }
}

.phone__container {
    width: 100%;
    max-width: 320px;
}

.app_iframe_sticky {
    position: sticky;
    overflow: auto;
    top: calc(57px + 0.5rem);
    height: 846px;
}
</style>
